import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-center flex-wrap",
  style: {"gap":"5px"}
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "justify-start flex-wrap mb-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Colaborador Origem", -1)
const _hoisted_5 = { class: "area-responsibles" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "justify-start flex-wrap mb-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Colaborador Destino", -1)
const _hoisted_9 = { class: "area-responsibles" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "justify-start flex-wrap mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Licenças da Colaborador Origem", -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "text-center"
}
const _hoisted_16 = {
  key: 2,
  class: "text-center"
}
const _hoisted_17 = {
  key: 3,
  class: "text-center"
}

import { ref, watch, withDefaults, onMounted } from 'vue';
import { MoleculeModal, MoleculeListActions } from '@/components/molecules';
import { Application, Company, Group, Licence, LicenceGroup, User } from '@/core/model';
import { create, getCollaboratorByGroups, update } from '@/core/service/UserService';

import { validateCPF, validateEmail } from '@/core/service/ValidateService';
import { Preloader } from '@/store';
import Swal from 'sweetalert2';
import { AtomInput, AtomButton, SearchIcon, AtomCheckBox, AtomAccordion, AtomSelect } from '@/components/atoms';
import { computed } from 'vue';
import { Authentication } from '@/store';
import { IHeadersTable, IOptionsSelect } from '@/types';
import { getHeadquartersByUser, getSubsidiariesByHeadquartersId } from '@/core/service/CompanyService';
import { getAll } from '@/core/service/UserService';
import { getByCollaborator, transferLicence } from '@/core/service/LicenceGroupService';
import { format } from 'date-fns';

interface IProps {
  showModal: boolean;
  group?: Group;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTransferLicenseModal',
  props: {
    showModal: { type: Boolean, default: false },
    group: null
  },
  emits: ['onHandleClose', 'setColaborator'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, group?: Group };

const optionsColaborator = ref<IOptionsSelect[]>([]);

const searchColaboratorOrigin = computed(() => {
  return searchOrigin.value
    ? Authentication.getters.isCollaborator.value
      ? optionsColaborator.value.filter(
          (f) =>
            f.text?.toUpperCase()?.includes(searchOrigin.value.toUpperCase()) &&
            f.value == Authentication.getters.getUser.value.mkId
        )
      : optionsColaborator.value.filter((f) => f.text?.toUpperCase()?.includes(searchOrigin.value.toUpperCase()))
    : Authentication.getters.isCollaborator.value
    ? optionsColaborator.value.filter((f) => f.value == Authentication.getters.getUser.value.mkId)
    : optionsColaborator.value;
});

const searchColaboratorDestiny = computed(() => {
  return !data.value.colaborator_origin
    ? []
    : searchDetiny.value
    ? optionsColaborator.value.filter(
        (f) => f.text?.toUpperCase()?.includes(searchDetiny.value.toUpperCase()) && f.value != data.value.colaborator_origin
      )
    : optionsColaborator.value.filter((f) => f.value != data.value.colaborator_origin);
});



const items = ref<any[]>([]);

const headers = ref<IHeadersTable[]>([
  { field: 'so', label: 'SO', type: 'image' },
  { field: 'version', label: 'Versão' },
  { field: 'expiration_dateFormat', label: 'Dt. Expiração' },
  { field: 'number_of_uses_left', label: 'Disponíveis' },
  { label: 'Ações', field: 'actions' },
]);

const disabledButton = computed(() => {
  return (
    !data.value.colaborator_destiny ||
    !data.value.colaborator_origin ||
    items.value.filter((f) => (f.number_of_uses ?? 0) > 0).length == 0
  );
});
const searchOrigin = ref<string>('');
const searchDetiny = ref<string>('');

const data = ref<any>({});
const loading = ref<boolean>(false);

function clear() {
  data.value = {};
  emit('onHandleClose', false);
}
function loadLicense() {
  if (!data.value.colaborator_origin) {
    items.value = [];
    return;
  }

  loading.value = true;
  getByCollaborator(data.value.colaborator_origin)
    .then((resp) => {
      items.value = resp.data.map((f) => {
        return {
          licence: f.licence,
          id: f.id,
          version: f.licence?.application_version?.version,
          so: `assets/os/${f.licence?.application_version.platform}.png`,
          expiration_dateFormat: format(new Date(f.licence?.expiration_date), 'dd/MM/yyyy'),
          number_of_uses_left: f.number_of_uses_left,
          number_of_uses: 0,
        };
      });
    })
    .finally(() => {
      loading.value = false;
    });
}
function setColaborator(payload: any, field: string) {
  if (data.value[field] && data.value[field] == payload.value) data.value[field] = undefined;
  else data.value[field] = payload.value;
  if (field == 'colaborator_destiny') {
    loadLicense();
  }
}

function loadColaborator() {
  if (props.group?.id)
    getCollaboratorByGroups([props.group?.id]).then((f) => {
      optionsColaborator.value = f.data.map((x) => {
        return { text: x.name, value: x.id };
      });
    });
}

async function handleTransfer() {
  let results = [];
  let result: any;
  for (const it of items.value.filter((f) => f.number_of_uses != null && f.number_of_uses > 0)) {
    result = await transferLicence({
      destination_collaborator_id: data.value.colaborator_destiny,
      destination_group_id: props.group?.id,
      origin_id: it.id,
      quantity_uses_transfer: it.number_of_uses,
    });
    results.push(Boolean(result.success));
  }
  await loadLicense();
  await Swal.fire({
    icon: results.every((f) => f) ? 'success' : 'warning',
    title: results.every((f) => f) ? 'Sucesso' : 'Atenção',
    text: results.every((f) => f)
      ? 'Todos as licenças selecionadas foram transferidas'
      : 'Atenção, seu pedido foi atendido parcialmente!',
  });
  if (results.every((f) => f)) emit('onHandleClose', false);
}

watch(
  () => props.showModal,
  () => {
    if (props.showModal) {
      data.value = {};
      items.value = [];
      loadColaborator();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    width: "649px",
    onHandleConfirm: handleTransfer,
    onHandleCancel: clear,
    icon: "ArchiveBookIcon",
    iconColor: "#5528B5",
    title: "Transferência de Licenças",
    show: __props.showModal,
    "btn-close-text": "Cancelar",
    "btn-confirm-text": "Enviar",
    btnConfitmDisabled: _unref(disabledButton)
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(AtomInput), {
              "append-icon": "",
              prependIcon: "",
              noBgPrependIcon: "",
              noBorderPrependIcon: "",
              placeholder: "Pesquisar",
              modelValue: searchOrigin.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchOrigin).value = $event)),
              width: "100%",
              classes: "w-100 my-3"
            }, _createSlots({
              prependIcon: _withCtx(() => [
                _createVNode(_unref(SearchIcon))
              ]),
              _: 2
            }, [
              (searchOrigin.value)
                ? {
                    name: "appendIcon",
                    fn: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                    () => {
                      searchOrigin.value = '';
                    }
                  , ["prevent","stop"]))
                      }, " X ")
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchColaboratorOrigin), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["d-flex align-center justify-space-between py-6 px-4 border rounded item-user mb-5", { active: data.value?.colaborator_origin === item.value }]),
                  onClick: ($event: any) => (setColaborator(item, 'colaborator_origin'))
                }, [
                  _createElementVNode("p", null, _toDisplayString(item.text), 1),
                  _createVNode(_unref(AtomCheckBox), {
                    onClick: ($event: any) => (setColaborator(item, 'colaborator_origin')),
                    checked: data.value.colaborator_origin === item.value
                  }, null, 8, ["onClick", "checked"])
                ], 10, _hoisted_6))
              }), 128))
            ])
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_unref(AtomInput), {
              "append-icon": "",
              prependIcon: "",
              noBgPrependIcon: "",
              noBorderPrependIcon: "",
              placeholder: "Pesquisar",
              modelValue: searchDetiny.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchDetiny).value = $event)),
              width: "100%",
              classes: "w-100 my-3"
            }, _createSlots({
              prependIcon: _withCtx(() => [
                _createVNode(_unref(SearchIcon))
              ]),
              _: 2
            }, [
              (searchDetiny.value)
                ? {
                    name: "appendIcon",
                    fn: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
                    () => {
                      searchDetiny.value = '';
                    }
                  , ["prevent","stop"]))
                      }, " X ")
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue"]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchColaboratorDestiny), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["d-flex align-center justify-space-between py-6 px-4 border rounded item-user mb-5", { active: data.value?.colaborator_destiny === item.value }]),
                  onClick: ($event: any) => (setColaborator(item, 'colaborator_destiny'))
                }, [
                  _createElementVNode("p", null, _toDisplayString(item.text), 1),
                  _createVNode(_unref(AtomCheckBox), {
                    onClick: ($event: any) => (setColaborator(item, 'colaborator_destiny')),
                    checked: data.value?.colaborator_destiny === item.value
                  }, null, 8, ["onClick", "checked"])
                ], 10, _hoisted_10))
              }), 128))
            ])
          ]),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            (items.value.length)
              ? (_openBlock(), _createBlock(_unref(MoleculeListActions), {
                  key: 0,
                  headers: headers.value,
                  items: items.value
                }, {
                  actions: _withCtx(({ data }) => [
                    _createVNode(_unref(AtomInput), {
                      modelValue: data.number_of_uses,
                      "onUpdate:modelValue": ($event: any) => ((data.number_of_uses) = $event),
                      "prepend-icon": "",
                      "append-icon": "",
                      "max-width": '142px',
                      type: "number",
                      min: "0",
                      max: data.number_of_uses_left,
                      height: "32px",
                      alignInput: "center"
                    }, {
                      appendIcon: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (
                        data.number_of_uses + 1 > data.number_of_uses_left
                          ? data.number_of_uses_left
                          : (data.number_of_uses += 1)
                      ), ["prevent"])
                        }, " + ", 8, _hoisted_13)
                      ]),
                      prependIcon: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (data.number_of_uses > 0 ? (data.number_of_uses -= 1) : null), ["prevent"])
                        }, " - ", 8, _hoisted_14)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "max"])
                  ]),
                  _: 1
                }, 8, ["headers", "items"]))
              : (!!data.value.colaborator_origin && !!data.value.colaborator_destiny)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_15, " Não há licenças para serem transferidas "))
                : (!data.value.colaborator_origin)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_16, "Selecione um Colaborador de Origem"))
                  : (!data.value.colaborator_destiny)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_17, "Selecione um Colaborador de Destino"))
                    : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show", "btnConfitmDisabled"]))
}
}

})